/* AD-09 · BACKUPS, AUDIT & SLO
   ADM-21/23/44: rehearsed restore is a launch gate; immutable audit; SLO
   dashboards with owner + trend. · Bible XV · Backups doc */
import { Card, KV, Note } from '@/ui'
import { useAdmin } from './AdminShell'
import Mark from './Mark'

export default function AD09Backups() {
  const rows = useAdmin().backups
  return (
    <section data-frame="AD-09" style={{ display: 'grid', gap: 14 }}>
      <h2 className="t-section">Sauvegardes, audit &amp; SLO</h2>
      <Card>
        <KV rows={rows.map(r => [
          r.label,
          r.status
            ? <>{r.value} <Mark cell={r.status} /></>
            : r.value,
        ])} />
      </Card>
      <Note tone="candour">
        Les valeurs v3.2 sont des hypothèses de lancement à re-baseliner sous charge
        représentative (décision registre) — jamais affichées comme garanties.
      </Note>
    </section>
  )
}
